// src/components/Header.js
import React from 'react';
import './Header.css';

function Header({ location_key }) {  

  const displayLocation = location_key.includes('_Ort_')  // Check if "_Ort_" is part of location_key
      ? location_key.split('_Ort_')[1] 
      : location_key.includes('_Landkreis_')  // Check if "_Landkreis_" is part of location_key
        ? location_key.split('_Landkreis_')[1]
        : location_key.includes('_Gemeinde_')  // Check if "_Gemeinde_" is part of location_key
          ? location_key.split('_Gemeinde_')[1]
          : location_key;  // Fallback if "_Ort_", "_Landkreis_" and "_Gemeinde_" is not present


  return (
    <header classname="app-header bg-white text-black p-5 text-center text-2xl font-bold">
      <h1 className="text-3xl sm:text-4xl md:text-5xl text-left p-10">
          Energiewende-Dashboard {displayLocation}</h1>

      {/* put a navigation bar here */}
    </header>
  );
}

export default Header;
